import { Routes } from '@angular/router';
import { SessionsComponent } from './components/sessions/sessions.component';
import { SessionComponent } from './components/session/session.component';
import { CreatesessionComponent } from './components/createsession/createsession.component';
import { LoginComponent } from './components/login/login.component';
import { authGuard } from './guards/authGuard';
import { PermissionDeniedComponent } from './components/permission-denied/permission-denied.component';
import { AdminComponent } from './components/admin/admin/admin.component';

export const routes: Routes = [
    { path: '', redirectTo: 'sessions', pathMatch:'full' },
    { path: 'sessions', component: SessionsComponent, canActivate: [authGuard]  },
    { path: 'session/:id', component: SessionComponent, canActivate: [authGuard] },
    { path: 'createsession', component: CreatesessionComponent, canActivate: [authGuard]},
    { path: 'login', component: LoginComponent },
    { path: 'permissiondenied', component: PermissionDeniedComponent},
    { path: 'admin', component: AdminComponent, canActivate: [authGuard]},
    { path: 'settings', redirectTo: 'admin', pathMatch: 'full' }
];
